import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["disabled", "type"]
const _hoisted_2 = {
  key: 0,
  src: "/assets/icon/ic-btn-icon.svg",
  class: "w-10 h-10 mr-1",
  alt: "icon"
}
const _hoisted_3 = {
  key: 1,
  src: "/assets/icon/ic-btn-icon-disabled.svg",
  class: "w-10 h-10 mr-1",
  alt: "icon"
}
const _hoisted_4 = {
  key: 1,
  class: "w-10 h-10 rounded-full flex items-center justify-center bg-white mr-1"
}

import { CheckIcon } from '@heroicons/vue/24/outline'

export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonComponent',
  props: {
    type: {
        type: String,
        default: 'button'
    },
    color: {
        type: String,
        default: 'primary'
    },
    expand: {
        type: String,
        default: null // block, full
    },
    fill: {
        type: String,
        default: 'solid' // clear, outline, solid
    },
    size: {
        type: String,
        default: 'large' // small, default, large
    },
    disabled: {
        type: Boolean,
        default: false
    },
    text: {
        type: String,
        default: null
    },
    showIcon: {
        type: Boolean,
        default: true
    },
    selectButton: {
        type: Boolean,
        default: false
    },
    selected: {
        type: Boolean,
        default: false
    },
    secondary: {
        type: Boolean,
        default: false
    },
    shadow: {
        type: Boolean,
        default: false
    }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    disabled: __props.disabled,
    type: __props.type,
    class: _normalizeClass(["inline-flex items-center text-center justify-center border-solid border-2 h-[50px] rounded-full text-white pl-2 transition-colors ease-in relative focus:border-primary-200 focus:after:opacity-0 after:absolute after:left-0 after:w-[70%] after:h-full after:z-[-1] after:rounded-l-full after:opacity-0 after:transition-all after:duration-300 after:bg-gradient-to-r after:from-white/50 after:to-transparent hover:after:opacity-100 hover:after:z-10 disabled:after:opacity-0 disabled:bg-neutral-200 disabled:border-neutral-200", [
        __props.secondary || __props.selectButton ? 'bg-primary-200 border-primary-200' : 'bg-primary-500 border-primary-500',
        __props.selected ? 'bg-primary-500 border-primary-500' : '',
        __props.shadow ? 'shadow-[5px_7px_9px_0_rgba(0,0,0,0.15)]' : ''
    ]])
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["font-bold pl-4 mx-auto", __props.showIcon ? 'pr-3' : 'pr-5'])
    }, _toDisplayString(__props.text), 3),
    (__props.showIcon)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!__props.disabled)
            ? (_openBlock(), _createElementBlock("img", _hoisted_2))
            : (_openBlock(), _createElementBlock("img", _hoisted_3))
        ], 64))
      : _createCommentVNode("", true),
    (__props.selectButton)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_unref(CheckIcon), {
            class: _normalizeClass(["w-5 h-5 text-primary-500", __props.selected ? 'opacity-100' : 'opacity-0'])
          }, null, 8, ["class"])
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})